import { ICONS_BY_NAME } from "../components/documentTypeIcons.js";

/**
 * Label/icon for `type`, read entirely from the type-counts endpoint's
 * `document_types` (label/sort_order/icon per DocumentType) - no frontend
 * constant stands in for a DocumentType's own data. A slug document_types
 * doesn't return (not yet configured as a DocumentType) falls back to the
 * raw value as its own label and no icon.
 *
 * @param {Array<{slug: string, label: string, icon: string}>} documentTypes
 */
export function metaForType(type, documentTypes = []) {
  const known = documentTypes.find((document_type) => document_type.slug === type);

  return {
    label: known?.label ?? type,
    Icon: known ? (ICONS_BY_NAME[known.icon] ?? null) : null,
  };
}
